import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { NonHoverBorder } from 'src/theme/colors';

const DRAWER_CONTAINER_WIDTH = 360;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: DRAWER_CONTAINER_WIDTH,
      height: '-webkit-fill-available',
      flexShrink: 0,
      borderRight: `1px solid ${NonHoverBorder}`,
      border: 'none',
      overflow: 'hidden',
      zIndex: theme.zIndex.drawer + 1,
      // mobile styles
      [theme.breakpoints.down('xs')]: {
        width: '100%',
        borderRight: 'none',
      },
    },
  }),
);

export const SideDrawer: React.FC = ({ children }) => {
  const classes = useStyles();

  return <div className={classes.root}>{children}</div>;
};
